/* PetsPortrait theme: product page (gallery, zoom, step configurator with product formats, suitcase, add to basket). */
(function () {
  'use strict';
  const PP = window.PP; if (!PP) return;
  const { RM, $, $$, buzz, ease3 } = PP;
  const DESK = matchMedia('(min-width: 980px)');
  const PAW = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><ellipse cx="12" cy="15.5" rx="5" ry="4"/><circle cx="6" cy="10" r="2.2"/><circle cx="9.5" cy="6" r="2.2"/><circle cx="14.5" cy="6" r="2.2"/><circle cx="18" cy="10" r="2.2"/></svg>';
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const FKEYS = ['frame', 'canvas', 'glow', 'circle', 'poster', 'suitcase'];

  function init(sec) {
    const dataEl = $('[data-product-json]', sec); if (!dataEl || sec._pdp) return; sec._pdp = true;
    const P = JSON.parse(dataEl.textContent);
    const I = JSON.parse(($('[data-pdp-i18n]', sec) || {}).textContent || '{}');
    const dec = s => { const t = document.createElement('textarea'); t.innerHTML = s; return t.value };
    const tt = (k, map) => { let s = dec(I[k] || ''); if (map) Object.keys(map).forEach(m => { s = s.split('{' + m + '}').join(map[m]) }); return s };
    const clean = v => String(v || '').replace(/&lt;\/?transcy&gt;/g, '').replace(/<[^>]*>/g, '').replace(P.marker || '\u0000', '').replace(/\s*\([^)]*\)\s*$/, '').replace(/\s+/g, ' ').trim();
    const pickIndex = P.pickIndex == null ? -1 : P.pickIndex;
    const fmtOf = v => (P.fmtMap && P.fmtMap[v]) || '';

    /* ===================== gallery (format slides first, filtered per format) ===================== */
    const GAL = (function () {
      const tr = $('[data-gtrack]', sec); if (!tr) return { figs: [], vis: () => [], go() {}, setFmt() {} };
      const all = $$('figure', tr), cnt = $('[data-gcount]', sec), th = $('[data-thumbs]', sec), cap = $('[data-gcap]', sec);
      const jsThumbs = th && th.hasAttribute('data-thumbs-js');
      let figs = all.slice(), cur = -1;
      const go = (i, smooth = true) => tr.scrollTo({ left: i * tr.clientWidth, behavior: RM || !smooth ? 'auto' : 'smooth' });
      function bindThumbs() { th && [...th.children].forEach((b, i) => { b.onclick = () => go(i) }) }
      function setFmt(f) {
        figs = all.filter(x => !x.dataset.fmt || x.dataset.fmt === (f || P.defaultFormat));
        if (!figs.length) figs = all.slice();
        all.forEach(x => { x.hidden = !figs.includes(x) });
        if (jsThumbs) th.innerHTML = figs.map((x, i) => `<button type="button" aria-label="${i + 1}"><img src="${esc(x.dataset.thumb || '')}" width="100" height="100" alt="" loading="lazy"></button>`).join('');
        bindThumbs(); tr.scrollLeft = 0; cur = -1; upd();
        const first = $('img', figs[0]); if (first && first.loading === 'lazy') first.loading = 'eager';
      }
      const upd = () => {
        const i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); if (i === cur || !figs[i]) return; cur = i;
        if (cnt) cnt.textContent = (i + 1) + ' / ' + figs.length;
        th && [...th.children].forEach((d, k) => d.setAttribute('aria-current', k === i));
        const t = th && th.children[i]; if (t && !DESK.matches) th.scrollTo({ left: t.offsetLeft - (th.clientWidth - t.offsetWidth) / 2, behavior: RM ? 'auto' : 'smooth' });
        if (cap) {
          const c = figs[i] ? figs[i].dataset.cap : '';
          const set = () => { cap.textContent = c; cap.hidden = !c; cap.classList.remove('swap') };
          if (RM) set(); else { cap.classList.add('swap'); clearTimeout(cap._t); cap._t = setTimeout(set, 180) }
        }
        const nx = figs[i + 1] && $('img', figs[i + 1]); if (nx && nx.loading === 'lazy') nx.loading = 'eager';
      };
      bindThumbs();
      let r; tr.addEventListener('scroll', () => { cancelAnimationFrame(r); r = requestAnimationFrame(upd) }, { passive: true }); upd();
      tr.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, Math.min(figs.length - 1, cur + (e.key === 'ArrowRight' ? 1 : -1)))) } else if (e.key === 'Enter') ZV.open(Math.max(0, cur), galList()) });
      $$('.garr', sec).forEach(b => b.addEventListener('click', () => go((cur + +b.dataset.d + figs.length) % figs.length)));
      let down = false, sx = 0, sl = 0, moved = 0;
      tr.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button) return; down = true; moved = 0; sx = e.clientX; sl = tr.scrollLeft; tr.style.scrollSnapType = 'none' });
      addEventListener('pointermove', e => { if (!down) return; moved = Math.max(moved, Math.abs(e.clientX - sx)); tr.scrollLeft = sl - (e.clientX - sx) });
      addEventListener('pointerup', e => { if (!down) return; down = false; tr.style.scrollSnapType = ''; if (moved < 6) return; const d = e.clientX - sx; const t = Math.abs(d) > 60 ? cur + (d < 0 ? 1 : -1) : cur; go(Math.max(0, Math.min(figs.length - 1, t))) });
      tr.addEventListener('dragstart', e => e.preventDefault());
      all.forEach(f => f.addEventListener('click', () => { if (moved > 6) { moved = 0; return } ZV.open(figs.indexOf(f), galList()) }));
      const gz = $('[data-gzoom]', sec); gz && gz.addEventListener('click', () => ZV.open(Math.max(0, cur), galList()));
      return { vis: () => figs, go, setFmt };
    })();
    function galList() {
      return GAL.vis().map(f => { const im = $('img', f); return { src: f.dataset.full || (im && (im.currentSrc || im.src)) || '', thumb: f.dataset.thumb || (im && im.src) || '', cap: f.dataset.cap || '', alt: im ? im.alt : '' } });
    }

    /* ===================== full-screen zoom (photos or suitcase artworks) ===================== */
    const ZV = (function () {
      const zv = $('[data-zv]', sec); if (!zv) return { open() {} };
      const stage = $('[data-zv-stage]', zv), strip = $('[data-zv-strip]', zv), thumbs = $('[data-zv-thumbs]', zv), zbtn = $('[data-zv-zoom]', zv);
      let list = [], N = 0, idx = 0, lastFocus, sc = 1, tx = 0, ty = 0, imgs = [], onClose = null;
      function build(l) {
        list = l; N = list.length; strip.innerHTML = ''; thumbs.innerHTML = ''; imgs = [];
        list.forEach((s, i) => {
          const sl = document.createElement('div'); sl.className = 'zv-slide';
          const im = document.createElement('img'); im.className = 'zv-img'; im.alt = s.alt || ''; im.decoding = 'async'; im.dataset.src = s.src; im.draggable = false;
          sl.appendChild(im); strip.appendChild(sl); imgs.push(im);
          const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', String(i + 1));
          b.innerHTML = `<img src="${esc(s.thumb || s.src)}" width="100" height="100" alt="">`; b.addEventListener('click', () => show(i, true)); thumbs.appendChild(b);
        });
      }
      const load = i => { const im = imgs[i]; if (im && !im.getAttribute('src')) im.src = im.dataset.src };
      const place = anim => { strip.classList.toggle('anim', !!anim && !RM); strip.style.transform = `translateX(${-idx * 100}%)` };
      function applyZoom(anim) { const im = imgs[idx]; if (!im) return; im.classList.toggle('anim', !!anim && !RM); im.style.transform = `translate(${tx}px, ${ty}px) scale(${sc})`; zbtn.setAttribute('aria-label', sc > 1 ? zbtn.dataset.out : zbtn.dataset.in) }
      function resetZoom(anim) { if (!imgs[idx]) return; sc = 1; tx = 0; ty = 0; applyZoom(anim) }
      function clampPan() {
        const im = imgs[idx], W = stage.clientWidth, H = stage.clientHeight, w = im.offsetWidth * sc, h = im.offsetHeight * sc, ox = im.offsetLeft, oy = im.offsetTop;
        tx = w <= W ? (W - w) / 2 - ox : Math.min(-ox, Math.max(W - w - ox, tx));
        ty = h <= H ? (H - h) / 2 - oy : Math.min(-oy, Math.max(H - h - oy, ty));
      }
      function zoomAt(px, py, ns, anim) {
        const im = imgs[idx], r = stage.getBoundingClientRect();
        const x = px - r.left - im.offsetLeft, y = py - r.top - im.offsetTop;
        tx = x - (x - tx) * (ns / sc); ty = y - (y - ty) * (ns / sc); sc = ns;
        if (sc <= 1.01) { sc = 1; tx = 0; ty = 0 } else clampPan();
        applyZoom(anim);
      }
      function show(i, anim) {
        if (imgs[idx]) resetZoom(false);
        idx = (i + N) % N; place(anim); [idx, idx + 1, idx - 1].forEach(k => load((k + N) % N));
        $('[data-zv-count]', zv).textContent = (idx + 1) + ' / ' + N; $('[data-zv-cap]', zv).textContent = list[idx] ? list[idx].cap || '' : '';
        [...thumbs.children].forEach((b, k) => b.setAttribute('aria-current', k === idx));
        const t = thumbs.children[idx]; t && thumbs.scrollTo({ left: t.offsetLeft - (thumbs.clientWidth - t.offsetWidth) / 2, behavior: RM ? 'auto' : 'smooth' });
        zv.dataset.idx = idx;
      }
      function open(i, l, cb) { if (!l || !l.length) return; build(l); onClose = cb || null; lastFocus = document.activeElement; zv.hidden = false; document.body.classList.add('locked'); idx = 0; show(i, false); requestAnimationFrame(() => zv.classList.add('on')); setTimeout(() => $('[data-zv-close]', zv).focus({ preventScroll: true }), 60); buzz() }
      function close() { zv.classList.remove('on'); document.body.classList.remove('locked'); if (onClose) onClose(idx); else GAL.go(idx, false); setTimeout(() => { zv.hidden = true; stage.style.transform = ''; zv.style.background = '' }, RM ? 0 : 340); lastFocus && lastFocus.focus({ preventScroll: true }) }
      $('[data-zv-close]', zv).addEventListener('click', close);
      zbtn.addEventListener('click', () => { const r = stage.getBoundingClientRect(); zoomAt(r.left + r.width / 2, r.top + r.height / 2, sc > 1 ? 1 : 2.5, true) });
      $$('.zv-arr', zv).forEach(b => b.addEventListener('click', e => { e.stopPropagation(); show(idx + +b.dataset.d, true) }));
      zv.addEventListener('keydown', e => {
        if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') show(idx + 1, true); else if (e.key === 'ArrowLeft') show(idx - 1, true);
        else if (e.key === '+' || e.key === '=') zbtn.click(); else if (e.key === '-') resetZoom(true);
        else if (e.key === 'Tab') { const f = $$('button', zv).filter(x => x.offsetParent); const a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus() } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus() } }
      });
      const pts = new Map(); let mode = null, sx = 0, sy = 0, st = 0, ptx = 0, pty = 0, pd = 0, ps = 1, lastTap = 0, moved = false;
      stage.addEventListener('pointerdown', e => {
        if (e.target.closest('button')) return;
        stage.setPointerCapture(e.pointerId); pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pts.size === 2) { const [a, b] = [...pts.values()]; pd = Math.hypot(a.x - b.x, a.y - b.y) || 1; ps = sc; mode = 'pinch'; return }
        sx = e.clientX; sy = e.clientY; st = performance.now(); ptx = tx; pty = ty; moved = false; mode = sc > 1 ? 'pan' : 'idle';
      });
      stage.addEventListener('pointermove', e => {
        if (!pts.has(e.pointerId)) return; pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const dx = e.clientX - sx, dy = e.clientY - sy; if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
        if (mode === 'pinch' && pts.size === 2) { const [a, b] = [...pts.values()]; const d = Math.hypot(a.x - b.x, a.y - b.y); zoomAt((a.x + b.x) / 2, (a.y + b.y) / 2, Math.min(4, Math.max(1, ps * d / pd)), false); return }
        if (mode === 'pan') { tx = ptx + dx; ty = pty + dy; applyZoom(false); return }
        if (mode === 'idle' && moved) mode = Math.abs(dx) > Math.abs(dy) ? 'swipe' : 'down';
        if (mode === 'swipe') { strip.classList.remove('anim'); strip.style.transform = `translateX(calc(${-idx * 100}% + ${dx}px))` }
        if (mode === 'down') { const y = Math.max(0, dy); stage.style.transform = `translateY(${y}px) scale(${1 - Math.min(y, 400) / 2000})`; zv.style.background = `rgba(20,14,16,${.97 - Math.min(y, 300) / 500})` }
      });
      const up = e => {
        if (!pts.has(e.pointerId)) return; pts.delete(e.pointerId);
        const dx = e.clientX - sx, dy = e.clientY - sy, dt = Math.max(1, performance.now() - st);
        if (mode === 'pinch') { if (pts.size === 0) { clampPan(); applyZoom(true); mode = null } else { const p = [...pts.values()][0]; sx = p.x; sy = p.y; ptx = tx; pty = ty; mode = 'pan' } return }
        if (mode === 'pan') { clampPan(); applyZoom(true) }
        else if (mode === 'swipe') { const fast = Math.abs(dx) / dt > .5; if (Math.abs(dx) > stage.clientWidth * .18 || (fast && Math.abs(dx) > 30)) show(idx + (dx < 0 ? 1 : -1), true); else place(true) }
        else if (mode === 'down') { if (dy > 110) close(); else { stage.style.transition = 'transform .35s cubic-bezier(.22,1,.36,1)'; stage.style.transform = ''; zv.style.background = ''; setTimeout(() => stage.style.transition = '', 360) } }
        else if (!moved) { const now = performance.now(); if (now - lastTap < 300) { zoomAt(e.clientX, e.clientY, sc > 1 ? 1 : 2.5, true); lastTap = 0 } else lastTap = now }
        mode = null;
      };
      stage.addEventListener('pointerup', up); stage.addEventListener('pointercancel', up);
      stage.addEventListener('wheel', e => { if (!e.ctrlKey && Math.abs(e.deltaY) < Math.abs(e.deltaX)) return; e.preventDefault(); zoomAt(e.clientX, e.clientY, Math.min(4, Math.max(1, sc * (e.deltaY < 0 ? 1.15 : .87))), false) }, { passive: false });
      addEventListener('resize', () => { if (!zv.hidden) { place(false); resetZoom(false) } });
      return { open };
    })();

    if (P.simple) return initSimple(sec, P);

    /* ===================== configurator ===================== */
    const wiz = $('[data-wiz]', sec);
    if (!wiz) return;
    const panes = $$('.pane', wiz);
    const STEPS = panes.length;
    const stepOf = el => +el.dataset.step;
    const labels = panes.map(p => p.dataset.label || '');
    const vSelect = $('[data-variant-select]', wiz);
    const optSets = $$('fieldset[data-option]', wiz);
    const pickSet = optSets.find(f => f.dataset.kind === 'pick');
    const photoStep = stepOf($('[data-photo-step]', wiz));
    const pickPane = $('[data-pick-step]', wiz);
    const optsPane = panes.find(p => $('fieldset[data-kind="size"],fieldset[data-kind="count"],fieldset[data-kind="other"]', p));
    const S = { step: stepOf(panes[0]), max: stepOf(panes[0]), opts: [], later: false, name: '', dates: '', mem: false, touched: false, photo: null, hasUpload: false, ukMissing: false, sizeSet: false };
    const variantById = id => P.variants.find(v => v.id === +id);
    let variant = variantById(P.selected) || P.variants[0];
    S.opts = variant ? variant.options.slice() : [];

    const findVariant = opts => P.variants.find(v => v.options.every((o, i) => o === opts[i]));
    /* does any variant match the options before index oi plus this value? */
    const existsPrefix = (oi, val) => P.variants.some(v => v.options[oi] === val && v.options.every((o, i) => i === oi || !(i < oi || i === pickIndex) || o === S.opts[i]));
    const fkey = () => pickIndex > -1 && P.pickKind === 'format' ? (fmtOf(S.opts[pickIndex]) || P.defaultFormat) : (P.suitcase ? 'suitcase' : P.defaultFormat);
    const countOf = () => { if (P.countIndex < 0) return 1; const v = clean(S.opts[P.countIndex] || '1'); const n = parseInt(v, 10) || 1; return /\+/.test(v) ? Math.max(3, n) : n };
    const countIsMax = () => {
      if (P.countIndex < 0) return false;
      const set = optSets.find(f => +f.dataset.option === P.countIndex); if (!set) return false;
      const radios = $$('input', set).filter(r => !r.closest('.opt').hidden); return radios.length && radios[radios.length - 1].checked;
    };
    const sizeVal = () => P.sizeIndex < 0 ? '' : String(S.opts[P.sizeIndex] || '');
    const dims = v => {
      const c = clean(v); let m = c.match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
      if (m) return { w: parseFloat(m[1]), h: parseFloat(m[2]) };
      m = c.match(/[øØ]\s*(\d+)/); if (m) return { w: +m[1], h: +m[1], round: true };
      m = c.match(/(\d+)\s*l\b/i); if (m) { const l = +m[1]; return { w: Math.round(28 + l / 3.5), h: Math.round(45 + l / 3.4), vol: true } }
      return { w: 30, h: 40 };
    };
    const norm = v => clean(v).toLowerCase().replace(/\s|cm/g, '');

    /* ----- add-ons (per format, choice groups, variant per size) ----- */
    const addons = $$('[data-addon]', wiz).map(el => ({
      el, kind: el.dataset.kind, id0: +el.dataset.variant || 0, price0: +el.dataset.price || 0, id: +el.dataset.variant || 0, price: +el.dataset.price || 0,
      title: el.dataset.title, show: el.dataset.show, max: +el.dataset.max || 5, qty: 0,
      formats: (el.dataset.formats || '').split(',').filter(Boolean), sizes: el.dataset.sizes ? JSON.parse(el.dataset.sizes) : null,
      check: $('[data-addon-check]', el), group: el.closest('[data-addon-group]')
    }));
    addons.forEach(a => {
      if (a.kind === 'toggle') a.check.addEventListener('change', () => { a.qty = a.check.checked && a.id ? 1 : 0; renderPrice(); buzz() });
      else if (a.kind === 'choice') a.check.addEventListener('change', () => { addons.filter(x => x.group === a.group).forEach(x => { x.qty = x.check.checked && x.id ? 1 : 0 }); renderPrice(); buzz() });
      else {
        const out = $('[data-out]', a.el), minus = $('[data-minus]', a.el), plus = $('[data-plus]', a.el);
        const upd = () => { out.textContent = a.qty; minus.disabled = a.qty <= 0; plus.disabled = a.qty >= a.max };
        minus.addEventListener('click', () => { if (a.qty > 0) { a.qty--; upd(); renderFrame(); renderPrice(); buzz() } });
        plus.addEventListener('click', () => { if (a.qty < a.max) { a.qty++; upd(); renderFrame(); renderPrice(); buzz() } });
        upd(); a.upd = upd;
      }
    });
    /* "more pets" counter sits right under the pet tiles (same add-on, same logic), unless switched off in the editor */
    if (wiz.dataset.morePetsInline !== 'false') {
      const more = addons.find(a => a.kind === 'counter' && a.show === 'max_count'), countSet = $('fieldset[data-kind="count"]', wiz);
      if (more && countSet) { more.el.classList.add('add-inline'); countSet.after(more.el) }
    }
    function syncAddons() {
      const f = fkey(), sz = norm(sizeVal());
      addons.forEach(a => {
        let on = !a.formats.length || a.formats.includes(f);
        if (on && a.sizes) { const m = a.sizes.find(x => sz && x.t.indexOf(sz) > -1); if (m) { a.id = m.id; a.price = m.p; const pr = $('[data-addon-price]', a.el); if (pr) pr.textContent = '+' + PP.money(m.p) } else on = false }
        if (on && a.show === 'max_count') on = countIsMax();
        a.el.hidden = !on;
        if (!on && a.qty) { a.qty = 0; a.upd && a.upd(); if (a.check && a.kind !== 'choice') a.check.checked = false }
      });
      $$('[data-addon-group]', wiz).forEach(g => {
        const items = addons.filter(a => a.group === g), vis = items.filter(a => !a.el.hidden);
        g.hidden = vis.length < 2;
        if (g.hidden) items.forEach(a => { a.qty = 0 });
        else if (!vis.some(a => a.check.checked)) { vis[0].check.checked = true; items.forEach(x => { x.qty = x.check.checked && x.id ? 1 : 0 }) }
        else items.forEach(x => { x.qty = !x.el.hidden && x.check.checked && x.id ? 1 : 0 });
      });
    }

    /* ----- dates ----- */
    const { concept, deliver } = PP.eta();
    const dl = PP.deadlineDate();
    $$('[data-eta-text]', sec).forEach(e => { e.textContent = (e.dataset.template || '').replace('[date]', PP.fmtDate(deliver)) });
    $$('[data-eta-concept]', sec).forEach(e => e.textContent = PP.fmtDate(concept));
    $$('[data-eta-deliver]', sec).forEach(e => e.textContent = PP.fmtDate(deliver));
    $$('[data-intime]', sec).forEach(e => { e.hidden = !(dl && deliver <= dl && Date.now() < dl.getTime()) });

    /* ----- sheets: photo guide, examples ----- */
    const tipSheetEl = $('[data-sheet="tips"]', sec);
    const tipsSrc = document.querySelector('[data-section-type="tips"] .tips');
    if (tipSheetEl && tipsSrc) $('[data-sheet-tips]', tipSheetEl).innerHTML = tipsSrc.innerHTML.replace(/ rv( |")/g, '$1').replace(/ style="--d:[^"]*"/g, '');
    const tipSheet = PP.makeSheet(tipSheetEl);
    $$('[data-open-tips]', sec).forEach(b => b.addEventListener('click', () => tipSheet && tipSheet.open()));
    const casesSheetEl = $('[data-sheet="cases"]', sec), casesSheet = PP.makeSheet(casesSheetEl);
    $$('[data-open-cases]', sec).forEach(b => b.addEventListener('click', () => { if (!casesSheet) return; casesSheet.open(); PP.initCases && PP.initCases($('[data-cases]', casesSheetEl)) }));
    function touched() { S.touched = true }
    const sizeSet = optSets.find(f => +f.dataset.option === P.sizeIndex);
    const visSizes = () => sizeSet ? $$('input', sizeSet).filter(r => !r.closest('.opt').hidden).map(r => r.value) : [];
    const isDigVal = v => P.sizeIndex > -1 && P.variants.some(x => x.options[P.sizeIndex] === v && x.ship === false);
    const maxDim = () => Math.max(...visSizes().filter(v => !isDigVal(v)).map(v => { const d = dims(v); return Math.max(d.w, d.h) }), 1);

    /* ----- portrait previews (mini frames) ----- */
    function fillPets(box) {
      const n = Math.min(3, countOf()); box.dataset.n = n;
      const key = () => S.later ? 'later' : (S.photo ? 'p:' + S.photo : 'sample');
      const have = [...box.children];
      for (let i = 0; i < n; i++) {
        const k = key(); if (have[i] && have[i].dataset.k === k) continue;
        const el = document.createElement('div'); el.className = 'pet'; el.dataset.k = k;
        if (k === 'later') el.innerHTML = `<span class="ghost"><span>${PAW}${esc(tt('photo_follows'))}</span></span>`;
        else { el.innerHTML = S.photo ? '<span class="splash"></span>' : ''; const im = new Image(); im.alt = ''; im.src = S.photo || P.sample; if (!S.photo) im.style.objectPosition = '50% 42%'; el.appendChild(im) }
        have[i] ? box.replaceChild(el, have[i]) : box.appendChild(el);
      }
      [...box.children].slice(n).forEach(x => x.remove());
    }
    function mockFor() {
      if (S.photo || S.later || P.countIndex < 0 || countOf() < 2) return '';
      const c = S.opts[P.countIndex], hit = (variant && variant.options[P.countIndex] === c && variant.image) ? variant : P.variants.find(v => v.options[P.countIndex] === c && v.image);
      return hit ? hit.image : '';
    }
    function renderFrame() {
      const nm = S.name || (S.photo || S.later ? '' : (tt('sample_name') || 'Guus')), sub = S.mem ? S.dates : '';
      const pets = $('[data-pets]', sec);
      if (pets) { fillPets(pets); $('[data-fname]', sec).textContent = nm; $('[data-fsub]', sec).textContent = sub }
      /* before a photo is uploaded, 2+ pets show the product's own mockup for that count instead of the sample pasted side by side */
      const mock = mockFor();
      $$('.mf', sec).forEach(m => {
        m.className = 'mf mf-' + fkey() + (mock ? ' mf-mock' : ''); m.style.backgroundImage = mock ? `url("${mock}")` : '';
        fillPets($('.pets', m)); $('.mf-nm', m).textContent = nm; $('.mf-sub', m).textContent = sub;
      });
      const pv = $('[data-pv-photo]', sec); if (pv) pv.hidden = !S.photo;
    }

    /* ----- prices + summary ----- */
    const addonsTotal = () => addons.reduce((t, a) => t + (a.el.hidden ? 0 : a.qty * a.price), 0);
    const total = () => (variant ? variant.price : 0) + addonsTotal();
    const minFor = (oi, val) => { const ps = P.variants.filter(v => v.options[oi] === val && v.available !== false && v.ship !== false).map(v => v.price); return ps.length ? Math.min(...ps) : 0 };
    /* the deal: compare-at of the cheapest variant for an option value, and "Save x%" */
    const minVar = (oi, val) => P.variants.filter(v => v.options[oi] === val && v.available !== false && v.ship !== false).sort((a, b) => a.price - b.price)[0];
    const savePct = (p, c) => c > p ? Math.round((1 - p / c) * 100) : 0;
    const saveTxt = n => (tt('save_pct') || '-{pct}%').replace('{pct}', n);
    const setDeal = (sEl, cEl, price, cmp) => { const n = P.showCompare ? savePct(price, cmp) : 0; if (cEl) { cEl.hidden = !n; if (n) cEl.textContent = PP.money(cmp) } if (sEl) { sEl.hidden = !n; if (n) sEl.textContent = saveTxt(n) } };
    const onPick = () => pickPane && S.step === stepOf(pickPane);
    /* the heading shows the same number as the tiles and the footer: on the product step the cheapest variant of the chosen product */
    const isDigital = () => !!(variant && variant.ship === false);
    /* digital file variants ship nothing: the delivery date makes way for digital wording */
    function renderEta() {
      const dig = isDigital();
      $$('[data-eta-text]', sec).forEach(e => { e.textContent = dig ? tt('eta_digital') : (e.dataset.template || '').replace('[date]', PP.fmtDate(deliver)) });
      $$('[data-eta-deliver]', sec).forEach(e => e.textContent = dig ? tt('eta_digital_when') : PP.fmtDate(deliver));
      $$('[data-eta-tl3]', sec).forEach(e => e.textContent = dig ? tt('eta_digital_tl') : e.dataset.ship);
    }
    const headVar = () => onPick() && pickIndex > -1 && !isDigital() ? (minVar(pickIndex, S.opts[pickIndex]) || variant) : variant;
    let shown = total(), tw;
    const priceEls = () => [$('[data-price]', sec), $('[data-total]', sec), $('[data-subtotal]', sec), $('[data-bb-tot]', sec)].filter(Boolean);
    /* the heading keeps its "from" price until the visitor picks a format (or arrives with one in the URL) */
    const urlPicked = /[?&](fmt|format|variant)=/.test(location.search);
    const keepFrom = () => !!$('[data-price].is-from', sec) && !S.userPicked && !urlPicked;
    function paint(v) {
      const t = PP.money(v);
      const pm = $('[data-price]', sec);
      if (pm && !keepFrom()) { const hv = headVar(); pm.classList.remove('is-from'); pm.textContent = PP.money(hv ? hv.price : v) }
      [$('[data-total]', sec), $('[data-bb-tot]', sec)].forEach(e => e && (e.textContent = t));
      const sub = $('[data-subtotal]', sec), sl = $('[data-sub-lbl]', sec);
      if (sub) {
        const sc = $('[data-sub-cmp]', sec), ss = $('[data-sub-save]', sec);
        if (onPick() && pickIndex > -1 && !isDigital()) { const mv = minVar(pickIndex, S.opts[pickIndex]); sub.textContent = PP.money(mv ? mv.price : 0); if (sl) sl.textContent = tt('from_label', { name: pickName() }); setDeal(ss, sc, mv ? mv.price : 0, mv ? mv.compare : 0) }
        else { sub.textContent = t; if (sl) sl.textContent = sl.dataset.def || sl.textContent; setDeal(ss, sc, total(), variant && variant.compare > variant.price ? variant.compare + addonsTotal() : 0) }
      }
    }
    function pickName() {
      if (pickIndex < 0) return '';
      if (P.pickKind === 'format') { const k = fmtOf(S.opts[pickIndex]); return (k && P.pickNames && P.pickNames[k] && P.pickNames[k].name) || clean(S.opts[pickIndex]) }
      const card = pickSet && $$('.stc-card', pickSet).find(c => $('input', c).value === S.opts[pickIndex]);
      return card ? card.dataset.title : clean(S.opts[pickIndex]);
    }
    function renderPrice() {
      const v = total();
      if (Math.abs(v - shown) > .5) {
        priceEls().forEach(e => { e.classList.remove('bump'); void e.offsetWidth; e.classList.add('bump') });
        cancelAnimationFrame(tw);
        if (RM) { shown = v; paint(v) } else {
          const from = shown, t0 = performance.now();
          const f = t => { const k = Math.min(1, (t - t0) / 520); shown = from + (v - from) * ease3(k); paint(Math.round(shown)); if (k < 1) tw = requestAnimationFrame(f); else { shown = v; paint(v) } };
          tw = requestAnimationFrame(f);
        }
      } else paint(v);
      const cmp = $('[data-compare]', sec);
      const hv = headVar();
      if (cmp) { const show = !keepFrom() && P.showCompare && hv && hv.compare > hv.price; cmp.hidden = !show; if (show) cmp.textContent = PP.money(hv.compare) }
      const sv = $('[data-save]', sec); if (sv) { const n = !keepFrom() && P.showCompare && hv ? savePct(hv.price, hv.compare) : 0; sv.hidden = !n; if (n) sv.textContent = saveTxt(n) }
      renderLines();
    }
    function renderLines() {
      const ul = $('[data-lines]', sec); if (!ul) return;
      const base = pickIndex > -1 ? tt('fmt_size', { name: pickName(), size: clean(sizeVal()) }).replace(/,\s*$/, '') : [P.title, sizeVal() ? clean(sizeVal()) : ''].filter(Boolean).join(', ');
      const lines = [['base', base, variant ? variant.price : 0]];
      if (P.countIndex > -1 && countOf() > 1) lines.push(['pets', tt('pets_line', { n: clean(S.opts[P.countIndex]) }), 0]);
      P.options.forEach((name, i) => { if (i !== P.countIndex && i !== P.sizeIndex && i !== pickIndex && S.opts[i]) lines.push(['o' + i, name + ': ' + clean(S.opts[i]), 0]) });
      lines.push(['photo', S.photo || S.hasUpload ? tt('photo_yes') : tt('photo_later'), 0]);
      if (S.name) lines.push(['name', tt('name_line', { name: S.name }), 0]);
      if (S.mem) lines.push(['mem', tt('memorial_line') + (S.dates ? ', ' + S.dates : ''), 0]);
      addons.forEach((a, i) => { if (a.qty && !a.el.hidden) lines.push(['a' + i, (a.qty > 1 ? a.qty + ' x ' : '') + a.title, a.qty * a.price]) });
      const keep = new Set(lines.map(l => l[0]));
      [...ul.children].forEach(li => { if (!keep.has(li.dataset.k) && !li.classList.contains('leave')) { li.classList.add('leave'); setTimeout(() => li.remove(), RM ? 0 : 260) } });
      lines.forEach(([k, label, p], i) => {
        let li = ul.querySelector(`[data-k="${k}"]:not(.leave)`);
        const html = `<span>${esc(label)}</span><span>${p ? PP.money(p) : (k === 'base' ? '' : '✓')}</span>`;
        if (!li) { li = document.createElement('li'); li.dataset.k = k; li.className = 'enter'; li.innerHTML = html; ul.insertBefore(li, ul.children[i] || null) }
        else if (li.innerHTML !== html) li.innerHTML = html;
      });
      const eta2 = $('[data-eta2]', sec);
      if (eta2) eta2.textContent = S.later || S.mem ? tt('eta_later') : isDigital() ? tt('eta_digital_review', { concept: PP.fmtDate(concept) }) : tt('eta_review', { concept: PP.fmtDate(concept), deliver: PP.fmtDate(deliver) });
      renderEta();
      const bl = $('[data-bb-lbl]', sec);
      if (bl) bl.innerHTML = '<span class="stars" aria-hidden="true">★★★★★</span> ' + esc(tt('step_of', { n: S.step, total: STEPS, label: labels[S.step - 1] || '' }));
    }

    /* ----- options -> variant: hide what does not exist for the chosen product, show prices ----- */
    function popularFor(f) {
      const m = String(P.popular || '').split(',').map(x => x.split('=')).find(x => (x[0] || '').trim() === f);
      return m ? norm(m[1] || '') : '';
    }
    function renderTiles() {
      const f = fkey(), pop = popularFor(f), mx = maxDim();
      optSets.forEach(set => {
        const oi = +set.dataset.option, kind = set.dataset.kind;
        const radios = $$('input', set);
        if (kind === 'pick') {
          radios.forEach(r => { const d = $('[data-from]', r.closest('[data-pick-tile]')); if (d) { const mv = minVar(oi, r.value); d.innerHTML = mv ? esc(tt('from', { price: PP.money(mv.price) })) + (P.showCompare && mv.compare > mv.price ? ' <s>' + PP.money(mv.compare) + '</s>' : '') : '' } });
          return;
        }
        let firstVisible = null;
        radios.forEach(r => {
          const opt = r.closest('.opt');
          const exists = existsPrefix(oi, r.value);
          opt.hidden = !exists; if (exists && !firstVisible) firstVisible = r;
        });
        if (kind === 'size') {
          const shown = radios.filter(r => !r.closest('.opt').hidden), vis = shown.filter(r => !isDigVal(r.value)), g = set.querySelector('.sizeg');
          g.style.setProperty('--cols', Math.min(shown.length, 5)); g.classList.toggle('five', shown.length === 5);
          /* scale the longest side between 24 and 44px so the smallest size stays readable and the biggest fits its box */
          const longest = vis.map(r => { const d = dims(r.value); return Math.max(d.w, d.h) }), mn = Math.min(...longest);
          vis.forEach((r, i) => {
            const d = dims(r.value), t = mx > mn ? (longest[i] - mn) / (mx - mn) : 1, k = (24 + 20 * t) / longest[i], sh = $('[data-shape]', r.closest('.opt'));
            if (sh) { sh.className = 'shape ' + (P.suitcase ? 'suitcase' : f); sh.style.width = Math.round(d.w * k) + 'px'; sh.style.height = Math.round(d.h * k) + 'px' }
            const b = $('[data-pop-badge]', r.closest('.opt')); if (b) b.hidden = !(pop ? norm(r.value) === pop : (P.marker && r.value.indexOf(P.marker) > -1));
          });
        }
        const baseOpts = S.opts.slice(); baseOpts[oi] = firstVisible && firstVisible.value;
        const base = findVariant(baseOpts);
        radios.forEach(r => {
          const o = S.opts.slice(); o[oi] = r.value; const v = findVariant(o);
          const d = $('[data-delta]', r.closest('.opt'));
          r.disabled = !v || !v.available;
          r.closest('.opt').classList.toggle('na', !v || !v.available);
          if (!d) return;
          if (!v) { d.textContent = ''; return }
          if (kind === 'count') { const diff = base ? v.price - base.price : 0; d.textContent = diff > 0 ? '+' + PP.money(diff) : (diff < 0 ? '-' + PP.money(-diff) : tt('included')) }
          else d.textContent = PP.money(v.price);
        });
        /* choices that all cost the same (e.g. costumes) don't repeat the price on every tile */
        if (kind === 'other') {
          const ds = radios.filter(r => !r.closest('.opt').hidden).map(r => $('[data-delta]', r.closest('.opt'))).filter(Boolean);
          const same = ds.length > 1 && ds.every(d => d.textContent === ds[0].textContent);
          ds.forEach(d => { d.hidden = same });
        }
      });
    }
    function resolve(changed) {
      /* keep every later option valid for the earlier choices (sizes per product, costumes, counts) */
      optSets.forEach(set => {
        const oi = +set.dataset.option; if (oi === changed || set.dataset.kind === 'pick') return;
        if (existsPrefix(oi, S.opts[oi])) return;
        const vals = $$('input', set).map(r => r.value).filter(v => existsPrefix(oi, v));
        if (!vals.length) return;
        let pick = vals[0];
        /* sizes start on the cheapest one, so the price matches the 'from' price on the tiles (or on the most chosen size when that setting is on) */
        if (set.dataset.kind === 'size' && !S.sizeSet) {
          const low = v => Math.min(...P.variants.filter(x => x.options[oi] === v && x.available !== false && x.ship !== false && (pickIndex < 0 || x.options[pickIndex] === S.opts[pickIndex])).map(x => x.price));
          pick = vals.reduce((a, b) => low(b) < low(a) ? b : a, vals[0]);
          if (P.startPopular && S.userPicked) { const pop = popularFor(fkey()); const p2 = vals.find(v => norm(v) === pop); if (p2) pick = p2 }
        }
        S.opts[oi] = pick;
      });
    }
    function setVariant() {
      let v = findVariant(S.opts);
      if (!v) { v = P.variants.find(x => pickIndex < 0 || x.options[pickIndex] === S.opts[pickIndex]) || P.variants[0]; S.opts = v.options.slice() }
      optSets.forEach(set => { const oi = +set.dataset.option; $$('input', set).forEach(r => r.checked = r.value === S.opts[oi]) });
      variant = v;
      if (vSelect) vSelect.value = v.id;
      const add = $('[data-add]', wiz);
      if (add) { add.disabled = !v.available; if (!add._busy) add.textContent = v.available ? PP.t.addToCart : PP.t.soldOut }
      if (history.replaceState && !(window.Shopify && Shopify.designMode)) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u) }
    }
    function pickChanged(silent) {
      const f = fkey();
      const on = $('[data-on-fmt]', sec);
      if (on) on.textContent = P.pickKind === 'format' ? ((P.pickNames[f] && P.pickNames[f].as) || '') : tt('suitcase_in', { style: pickName() });
      GAL.setFmt(f);
      document.dispatchEvent(new CustomEvent('pp:format', { detail: { key: f, product: P.id } }));
      if (P.suitcase && pickSet) { const i = $$('input', pickSet).findIndex(r => r.checked); syncChips(i, silent) }
    }
    optSets.forEach(set => {
      const oi = +set.dataset.option;
      $$('input', set).forEach(r => r.addEventListener('change', () => {
        if (!r.checked) return;
        S.opts[oi] = r.value; buzz(); touched();
        if (oi === P.sizeIndex) S.sizeSet = true;
        if (oi === pickIndex) { S.userPicked = true; if (!S.sizeSet && P.sizeIndex > -1) S.opts[P.sizeIndex] = '' }
        resolve(oi); setVariant(); renderTiles(); syncAddons();
        if (oi === pickIndex) pickChanged(); else renderFrame(); renderPrice();
      }));
    });
    $$('[data-change-pick]', sec).forEach(b => b.addEventListener('click', () => pickPane && setStep(stepOf(pickPane))));

    /* ----- suitcase: style chips, centred card on mobile, artwork zoom, hero views ----- */
    let syncChips = () => {};
    if (P.suitcase && pickSet) {
      const chips = $('[data-stc-chips]', sec), cards = $$('.stc-card', pickSet);
      const centre = (i, smooth) => { const c = cards[i]; if (!c) return; pickSet.scrollTo({ left: c.offsetLeft - (pickSet.clientWidth - c.offsetWidth) / 2, behavior: smooth && !RM ? 'smooth' : 'auto' }) };
      const choose = (i, from) => { const r = $('input', cards[i]); if (!r || r.checked) return; r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); if (from !== 'scroll') centre(i, true) };
      if (chips) { PP.chipGroup(chips, k => choose(+k, 'chip')) }
      syncChips = (i, silent) => { if (!chips) return; $$('.chip', chips).forEach(c => c.setAttribute('aria-pressed', +c.dataset.f === i)); dispatchEvent(new Event('resize')); const c = $$('.chip', chips)[i]; if (c && !silent) chips.scrollTo({ left: c.offsetLeft - (chips.clientWidth - c.offsetWidth) / 2, behavior: RM ? 'auto' : 'smooth' }) };
      let st0; pickSet.addEventListener('scroll', () => { if (DESK.matches) return; clearTimeout(st0); st0 = setTimeout(() => { const mid = pickSet.scrollLeft + pickSet.clientWidth / 2; let best = 0, bd = 1e9; cards.forEach((c, i) => { const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i } }); choose(best, 'scroll') }, 140) }, { passive: true });
      requestAnimationFrame(() => centre(Math.max(0, cards.findIndex(c => $('input', c).checked)), false));
      /* zoom shows the suitcase mockup from the tile (the flat artwork only when a style has no mockup) */
      const arts = cards.map(c => ({ src: c.dataset.zoom || c.dataset.art, thumb: c.dataset.zoom || c.dataset.art, cap: c.dataset.title, alt: c.dataset.title }));
      /* a tap on the tile only selects the style; the zoom opens from the magnifier icon */
      $$('[data-stc-zoom]', pickSet).forEach((b, i) => b.addEventListener('click', e => { e.preventDefault(); choose(i, 'tap'); if (e.target.closest('.zi')) ZV.open(i, arts, k => { choose(k, 'zoom'); centre(k, false) }) }));
    }
    /* suitcase gallery: slide 1 shows the chosen style's suitcase mockup (same image as the tile); picking a style jumps back to it */
    const caseFig = $('[data-case-style]', sec);
    if (caseFig && pickSet) {
      const img = $('img', caseFig);
      const showStyle = jump => {
        const card = $$('.stc-card', pickSet).find(c => $('input', c).checked);
        const src = card && card.dataset.zoom;
        if (!src || src === card.dataset.art) return;
        const thumb = () => { const th = $('[data-thumbs] button img', sec); if (th) th.src = src };
        if (caseFig.dataset.full !== src) {
          caseFig.dataset.full = caseFig.dataset.thumb = src;
          const swap = () => { img.removeAttribute('srcset'); img.src = src; img.style.opacity = ''; thumb() };
          if (RM) swap(); else { img.style.transition = 'opacity .25s ease'; img.style.opacity = '0'; const pre = new Image(); pre.onload = pre.onerror = () => setTimeout(swap, 120); pre.src = src }
        } else thumb();
        if (jump) GAL.go(0);
      };
      pickSet.addEventListener('change', () => showStyle(true));
      showStyle(false);
    }

    /* ----- photo step: UploadKit ----- */
    const ukWrap = $('[data-uk-wrap]', wiz), uk = ukWrap && $('.uploadkit', ukWrap), ukWait = $('[data-uk-wait]', wiz);
    const later = $('[data-later]', wiz), laterInfo = $('[data-later-info]', wiz), photoErr = $('[data-photo-err]', wiz);
    const urlFrom = v => { const m = String(v || '').match(/https?:\/\/[^\s,"']+/); return m ? m[0] : '' };
    const previewFrom = u => {
      const m = u.match(/^(https?:\/\/[^/]+)\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i);
      if (m) return `${m[1]}/${m[2]}/-/preview/600x600/`;
      return /\.(jpe?g|png|webp|gif|heic)(\?|$)/i.test(u) ? u : '';
    };
    function scanUpload() {
      if (!uk) return;
      const present = uk.children.length > 0 && uk.innerHTML.trim().length > 0;
      if (present && ukWait) ukWait.hidden = true;
      const vals = $$('input', uk).filter(i => i.type !== 'file' && /^properties\[/.test(i.name || '') && String(i.value || '').trim());
      const has = vals.length > 0;
      let src = '';
      const img = $$('img', uk).find(i => /^https?:/.test(i.currentSrc || i.src || '') && (i.naturalWidth || 0) > 40);
      if (img) src = img.currentSrc || img.src;
      if (!src && has) src = previewFrom(urlFrom(vals[0].value));
      const changed = has !== S.hasUpload || (src || null) !== S.photo;
      S.hasUpload = has; S.photo = src || null;
      if (changed) { if (has) { photoErr.textContent = ''; touched() } renderFrame(); renderPrice(); updNext() }
    }
    if (uk) {
      new MutationObserver(scanUpload).observe(uk, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'src', 'class'] });
      uk.addEventListener('change', scanUpload, true); uk.addEventListener('input', scanUpload, true);
      setInterval(() => { if (S.step === photoStep || !S.hasUpload) scanUpload() }, 900);
      /* never block the order on our side when the uploader does not load */
      setTimeout(() => { if (uk.children.length === 0) { S.ukMissing = true; if (ukWait) { ukWait.textContent = tt('uploader_missing'); ukWait.hidden = false; ukWait.classList.add('uk-miss') } updNext() } }, 9000);
    }
    later && later.addEventListener('change', () => {
      S.later = later.checked; laterInfo.hidden = !S.later; photoErr.textContent = '';
      ukWrap && ukWrap.classList.toggle('off', S.later);
      renderFrame(); renderPrice(); touched(); buzz(); updNext();
    });
    /* a missing photo never blocks checkout: no photo means it is requested by email after the order */
    const noPhoto = () => !S.later && !S.hasUpload && !S.photo;

    /* ----- name + memorial mode (no urgency) ----- */
    const nameIn = $('[data-pet-name]', wiz), datesIn = $('[data-dates]', wiz), datesFld = $('[data-dates-fld]', wiz), memSw = $('[data-mem-switch]', wiz), notes = $('[data-notes]', wiz);
    try { const n = sessionStorage.getItem('pp_name'); if (n && nameIn && !nameIn.value) { nameIn.value = n; S.name = n } } catch (e) {}
    nameIn && nameIn.addEventListener('input', () => { S.name = nameIn.value.trim(); renderFrame(); renderPrice(); touched() });
    datesIn && datesIn.addEventListener('input', () => { S.dates = datesIn.value.trim(); renderFrame(); renderPrice(); touched() });
    function setMemorial(on) {
      S.mem = on; if (memSw) memSw.checked = on; if (datesFld) datesFld.hidden = !on; if (datesIn) datesIn.disabled = !on;
      document.body.classList.toggle('mem-mode', on);
      renderFrame(); renderPrice();
    }
    memSw && memSw.addEventListener('change', () => { setMemorial(memSw.checked); touched(); buzz() });
    $$('[data-mem-link]', sec).forEach(b => b.addEventListener('click', () => { if (!memSw) return; setMemorial(true); S.max = Math.max(S.max, stepOf(memSw.closest('.pane'))); setStep(stepOf(memSw.closest('.pane'))) }));
    $$('[data-sugg]', wiz).forEach(b => b.addEventListener('click', () => { if (!notes) return; if (!notes.value.includes(b.textContent)) notes.value = (notes.value.trim() ? notes.value.trim() + '. ' : '') + b.textContent; b.classList.add('used'); buzz() }));

    /* ----- stepper ----- */
    const nextBtn = $('[data-next]', wiz), nextLbl = $('[data-next-lbl]', wiz), foot = $('[data-wiz-foot]', wiz);
    const subLbl = $('[data-sub-lbl]', sec); if (subLbl) subLbl.dataset.def = subLbl.textContent;
    function updNext() {
      const n = S.step;
      if (foot) foot.hidden = n === STEPS;
      if (photoErr) { photoErr.textContent = n === photoStep && noPhoto() ? tt('photo_error') : ''; photoErr.classList.toggle('soft', !!photoErr.textContent) }
      if (nextLbl) nextLbl.textContent = n === STEPS - 1 ? tt('review_btn') : tt('next_btn', { label: labels[n] || '' });
    }
    function setStep(n) {
      const prev = S.step; S.step = n; S.max = Math.max(S.max, n);
      $$('[data-stepper] button', wiz).forEach(b => {
        const k = +b.dataset.go;
        if (k === n) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        b.classList.toggle('ok', k < n || (k <= S.max && k !== n));
        b.disabled = k > S.max;
      });
      const fill = $('[data-step-fill]', wiz); if (fill) fill.style.transform = `scaleX(${(n - 1) / Math.max(1, STEPS - 1)})`;
      panes.forEach(p => { const s = stepOf(p); p.style.setProperty('--from', (s < n ? -36 : 36) + 'px'); p.classList.toggle('on', s === n); p.inert = s !== n });
      updNext(); renderPrice(); updBar();
      if (n === photoStep) scanUpload();
      if (prev !== n) {
        const focusHead = () => { const h = $('h2', panes.find(p => stepOf(p) === n)); h && h.focus({ preventScroll: true }) };
        requestAnimationFrame(() => requestAnimationFrame(() => {
          const sp = $('[data-stepper]', wiz), hh = (document.querySelector('[data-hdr]:not(.hide)') || { getBoundingClientRect: () => ({ bottom: 0 }) }).getBoundingClientRect().bottom;
          const top = sp.getBoundingClientRect().top;
          focusHead();
          if (top < Math.max(0, hh) || top > innerHeight * .45) scrollTo({ top: Math.max(0, scrollY + top - 76), behavior: RM ? 'auto' : 'smooth' });
        }));
      }
    }
    panes.forEach(p => { const h = $('h2', p); h && h.setAttribute('tabindex', '-1') });
    nextBtn && nextBtn.addEventListener('click', () => { if (S.step < STEPS) { setStep(S.step + 1); buzz() } });
    $$('[data-stepper] button', wiz).forEach(b => b.addEventListener('click', () => { const n = +b.dataset.go; if (n > S.max) return; setStep(n) }));

    /* ----- add to basket: one /cart/add.js with the portrait line + add-on lines ----- */
    const addBtn = $('[data-add]', wiz), addErr = $('[data-add-err]', wiz);
    wiz.addEventListener('submit', async e => {
      if (e.defaultPrevented || !window.fetch || !window.FormData) return;
      e.preventDefault();
      if (!variant || !variant.available) return;
      const fd = new FormData(wiz); const properties = {};
      for (const [k, v] of fd.entries()) {
        const m = k.match(/^properties\[(.*)\]$/); if (!m || typeof v !== 'string') continue;
        if (v.trim() === '') continue; properties[m[1]] = v;
      }
      if (later && noPhoto()) properties[later.name.match(/^properties\[(.*)\]$/)[1]] = later.value;
      const items = [{ id: variant.id, quantity: 1, properties }];
      addons.forEach(a => { if (!a.el.hidden && a.qty > 0 && a.id) items.push({ id: a.id, quantity: a.qty }) });
      addBtn._busy = true; addBtn.disabled = true; addBtn.textContent = PP.t.adding; addErr.textContent = '';
      try {
        await PP.cart.add(items, { open: true });
        buzz([10, 30, 10]); addBtn.classList.add('done'); addBtn.textContent = PP.t.added;
        if (!document.querySelector('[data-cart-drawer]')) PP.toast(PP.t.added);
        setTimeout(() => { addBtn.classList.remove('done'); addBtn._busy = false; addBtn.disabled = false; addBtn.textContent = PP.t.addToCart }, 2400);
      } catch (err) {
        addBtn._busy = false; addBtn.disabled = false; addBtn.textContent = PP.t.addToCart; addErr.textContent = err.message || PP.t.error;
      }
    });

    /* ----- mobile return bar: never a duplicate of the visible button, never over an input ----- */
    const bb = $('[data-bb]', sec), bbGo = $('[data-bb-go]', sec);
    let actVis = true, typing = false, wizAbove = false;
    function updBar() {
      if (!bb) return;
      const show = !DESK.matches && !actVis && !typing && !document.body.classList.contains('locked');
      bb.classList.toggle('show', show);
      bbGo.textContent = wizAbove ? bbGo.dataset.back : bbGo.dataset.start;
    }
    if (bb) {
      new IntersectionObserver(es => es.forEach(e => { actVis = e.isIntersecting; wizAbove = !e.isIntersecting && e.boundingClientRect.top < 0; updBar() }), { threshold: .1 }).observe(wiz);
      document.addEventListener('focusin', e => { if (e.target.matches('input:not([type=radio]):not([type=checkbox]):not([type=file]),textarea')) { typing = true; updBar() } });
      document.addEventListener('focusout', () => { typing = false; setTimeout(updBar, 50) });
      bbGo.addEventListener('click', () => scrollTo({ top: scrollY + $('[data-stepper]', wiz).getBoundingClientRect().top - 76, behavior: RM ? 'auto' : 'smooth' }));
    }

    /* ----- init: ?fmt=frame|canvas|glow|circle|poster preselects (Shopify reserves ?format=) the product and opens the size step ----- */
    const q = new URLSearchParams(location.search);
    let startStep = S.step;
    if (pickIndex > -1 && P.pickKind === 'format') {
      const want = (q.get('fmt') || q.get('format') || '').toLowerCase();
      const val = Object.keys(P.fmtMap || {}).find(v => P.fmtMap[v] === want);
      if (val) { S.opts[pickIndex] = val; S.sizeSet = false; if (P.sizeIndex > -1) S.opts[P.sizeIndex] = ''; if (optsPane) { startStep = stepOf(optsPane); S.max = startStep } }
    }
    /* no product in the URL: open on the cheapest product, so heading, tile and footer match the 'from' price on the cards */
    if (pickIndex > -1 && P.pickKind === 'format' && P.startCheapest && !q.get('variant') && !q.get('fmt') && !q.get('format')) { const c = P.variants.filter(v => v.available !== false).sort((x, y) => x.price - y.price)[0]; if (c) S.opts[pickIndex] = c.options[pickIndex] }
    if (pickIndex > -1 && !q.get('variant')) { S.sizeSet = false; if (P.sizeIndex > -1 && !q.get('fmt') && !q.get('format')) S.opts[P.sizeIndex] = '' }
    resolve(-1); setVariant(); renderTiles(); syncAddons(); pickChanged(true); renderFrame(); setStep(startStep); renderPrice();
    if (/[?&]memorial=1/.test(location.search)) setMemorial(true);
    wiz.classList.add('ready');
  }

  /* ===== simple product + gift card form ===== */
  function initSimple(sec, P) {
    const form = $('[data-simple-form]', sec); if (!form) return;
    const sets = $$('fieldset[data-option]', form), sel = $('[data-variant-select]', form), add = $('[data-add]', form), err = $('[data-add-err]', form);
    let variant = P.variants.find(v => v.id === P.selected) || P.variants[0];
    const opts = variant.options.slice();
    const update = () => {
      variant = P.variants.find(v => v.options.every((o, i) => o === opts[i])) || variant;
      if (sel) sel.value = variant.id;
      const pm = $('[data-price]', sec); if (pm) { pm.textContent = PP.money(variant.price); pm.classList.remove('bump'); void pm.offsetWidth; pm.classList.add('bump') }
      const cmp = $('[data-compare]', sec); if (cmp) { const show = P.showCompare && variant.compare > variant.price; cmp.hidden = !show; if (show) cmp.textContent = PP.money(variant.compare) }
      add.disabled = !variant.available; add.textContent = variant.available ? PP.t.addToCart : PP.t.soldOut;
      sets.forEach(set => { const oi = +set.dataset.option; $$('input', set).forEach(r => { const o = opts.slice(); o[oi] = r.value; const v = P.variants.find(x => x.options.every((y, i) => y === o[i])); r.disabled = !v || !v.available }) });
      if (history.replaceState && !(window.Shopify && Shopify.designMode)) { const u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u) }
    };
    sets.forEach(set => { const oi = +set.dataset.option; $$('input', set).forEach(r => r.addEventListener('change', () => { if (r.checked) { opts[oi] = r.value; update(); buzz() } })) });
    const gcr = $('[data-gcr]', form);
    if (gcr) {
      const tg = $('[data-gcr-toggle]', gcr), fields = $('[data-gcr-fields]', gcr), off = $('[data-gcr-offset]', gcr);
      if (off) off.value = new Date().getTimezoneOffset().toString();
      const sync = () => { fields.hidden = !tg.checked; $$('input:not([data-gcr-offset]),textarea', fields).forEach(i => i.disabled = !tg.checked); if (off) off.disabled = !tg.checked };
      tg.addEventListener('change', sync); sync();
    }
    form.addEventListener('submit', async e => {
      if (e.defaultPrevented || !window.fetch) return;
      e.preventDefault(); err.textContent = ''; add.disabled = true; const label = add.textContent; add.textContent = PP.t.adding;
      try {
        const fd = new FormData(form);
        const secs = PP.cart.sections(); if (secs.length) { fd.append('sections', secs.join(',')); fd.append('sections_url', location.pathname) }
        const r = await fetch((PP.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const j = await r.json();
        if (!r.ok || j.status) throw new Error(j.description || j.message || PP.t.error);
        if (j.sections) PP.cart.render(j.sections); else await PP.cart.refresh();
        PP.cart.count(); PP.cart.open();
        if (!document.querySelector('[data-cart-drawer]')) PP.toast(PP.t.added);
        add.textContent = PP.t.added; setTimeout(() => { add.textContent = label; add.disabled = !variant.available }, 2000);
      } catch (x) { err.textContent = x.message; add.textContent = label; add.disabled = false }
    });
    update();
  }

  const boot = () => $$('[data-product-json]').forEach(el => init(el.closest('.shopify-section') || document.body));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => { if ($('[data-product-json]', e.target)) init(e.target) });
})();
